import _ from "underscore";
import UserSelectorGroupsStrategy from "./UserSelectorGroupsStrategy";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";
import TreeNodeSet from "../../hierarchySelector/tree/TreeNodeSet";
import UsersSelectorTree from "../../hierarchySelector/userSelector/UsersSelectorTree";
import ShowUserGroupsStrategy from './ShowUserGroupsStrategy'

HideUserGroupsStrategy.USER_NODE_LEVEL = 1;
HideUserGroupsStrategy.DISABLED_USER_NODE_LEVEL = 2;

HideUserGroupsStrategy.pleaseSelectMessageKey = "users_selector.no_users_selected";
HideUserGroupsStrategy.emptySelectionTooltipTextKey = "mail_notifications.users_selector.no_users_selected";
HideUserGroupsStrategy.noNodesMatchingSearchMessageKey = "users_selector.only_users.no_results_in_search";
HideUserGroupsStrategy.noSelectedNodesMessageKey = "users_selector.hide_not_selected.no_users_selected";

export default function HideUserGroupsStrategy( conf ) {
    UserSelectorGroupsStrategy.call(this);

    this.pleaseSelectMessageKey = conf && conf.pleaseSelectMessageKey ? conf.pleaseSelectMessageKey : HideUserGroupsStrategy.pleaseSelectMessageKey;
    this.emptySelectionTooltipTextKey = conf && conf.emptySelectionTooltipTextKey ? conf.emptySelectionTooltipTextKey : HideUserGroupsStrategy.emptySelectionTooltipTextKey;
    this.noNodesMatchingSearchMessageKey = conf && conf.noNodesMatchingSearchMessageKey ? conf.noNodesMatchingSearchMessageKey : HideUserGroupsStrategy.noNodesMatchingSearchMessageKey;
    this.noSelectedNodesMessageKey = conf && conf.noSelectedNodesMessageKey ? conf.noSelectedNodesMessageKey : HideUserGroupsStrategy.noSelectedNodesMessageKey;
}

HideUserGroupsStrategy.prototype = _.create(UserSelectorGroupsStrategy.prototype);

HideUserGroupsStrategy.prototype.canExpandCollapseNodes = function() {
    return false;
};

HideUserGroupsStrategy.prototype.createTree = function(rootNode, emptyMessageBuilder, collapsedNodeIds) {
    return new UsersSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds);
};

HideUserGroupsStrategy.prototype.isGroupNodeRendererNeeded = function() {
    return false;
};

HideUserGroupsStrategy.prototype.getAdditionalTreePanelClasses = function() {
    return ["oneLevelTree"];
};



HideUserGroupsStrategy.prototype.makeAllSelectedUsersSelection = function(nodeSet) {
    return this.makeOnlyUsersSelection(nodeSet);
};

HideUserGroupsStrategy.prototype.saveCollapsedNodesIntoCookies = function(tree, cookiesKey) {
    //do nothing
};

HideUserGroupsStrategy.prototype.makeNodeSet = function(selection, rootNode) {
    let nodeSet = new TreeNodeSet();
    HierarchySelectorUtil.addNodesFromIdsArray( selection.getSecondLevel(), nodeSet, rootNode, "u" );
    nodeSet.addAll(HierarchySelectorUtil.selectNodesParents(nodeSet, ShowUserGroupsStrategy.USER_NODE_LEVEL))
    return nodeSet;
};

HideUserGroupsStrategy.prototype.getUserNodeLevel = function () {
    return HideUserGroupsStrategy.USER_NODE_LEVEL;
};



// WEBPACK FOOTER //
// ./web/js/usersSelector/userSelectorGroupsStrategies/HideUserGroupsStrategy.js